<template>
    <div>
        <b-modal
                id="add-notification-popup"
                ref="modal"
                :title="titlePopup"
                size="sm"
                hide-footer
                no-close-on-backdrop
                modal-class="hide-footer"
                no-close-on-esc
                :hide-header-close="loading"
                @hidden="onHidden"
        >
            <b-form
                    @submit.stop.prevent="onSubmit()"
                    @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                                id="input-group-1"
                                label="Title"
                                label-for="title"
                        >
                            <b-form-input
                                    id="title"
                                    v-model="formData.title"
                                    v-validate="{
                                    required: true,
                                    min: 2,
                                    max: 100,
                                }"
                                    type="text"
                                    placeholder="Enter title"
                                    name="title"
                                    :class="{
                                    'is-invalid': errors.has('title'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-3"
                            label="Category"
                            label-for="category"
                        >
                            <b-form-select
                                id="category"
                                v-model="formData.category"
                                v-validate="{
                                    required: true,
                                }"
                                name="category"
                                class="form-control"
                                :class="{
                                    'is-invalid': errors.has('category'),
                                }"
                                :options="categoryOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <!-- <div class="col-md-12" v-if="formData.category=='external'">
                        <b-form-group
                                id="input-group-1"
                                label="Link"
                                label-for="link"
                        >
                            <b-form-input
                                    id="link"
                                    v-model="formData.link"
                                    v-validate="{
                                    required: true,
                                    required: formData.category == 'external',
                                    min: 1,
                                    max: 100,
                                }"
                                    type="text"
                                    placeholder="Enter link"
                                    name="link"
                                    :class="{
                                    'is-invalid': errors.has('link'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div> -->
                    <div class="col-md-12" v-if="formData.category">
                        <b-form-group
                                id="input-group-1"
                                label="Description"
                                label-for="description"
                        >
                            <b-form-textarea
                                    id="description"
                                    v-model="formData.description"
                                    v-validate="getMeta.validate"
                                    :rows="getMeta.rows"
                                    :placeholder="getMeta.placeholder"
                                    name="description"
                                    :class="{
                                    'is-invalid': errors.has('description'),
                                }"
                            ></b-form-textarea>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                                id="input-group-1"
                                label="Expires At"
                                label-for="expiresAt"
                        >
                        <div class="form-group custom-datepicker">
                                        <date-picker
                                                ref="expiresAt"
                                                v-model="formData.expiresAt"
                                                class="form-control"
                                                name="expiresAt"
                                                format="DD/MM/YYYY"
                                                lang="en"
                                                :start-at="disabledDate"
                                                :class="{
                                                                    'is-invalid':
                                                                        errors.has(
                                                                            'expiresAt'
                                                                        ),
                                                                }"

                                        ></date-picker>

                                        <i :class="[{'disable-input': false,},'icon-calendar', ]"></i>
                                    </div>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">

<b-form-group
        id="allDataSegments"
        label="All DataSegments"
        label-for="allDataSegments"
>
    <b-form-radio-group
            v-model="formData.allDataSegments"
            autocomplete="no"
            :options="boolVal"
            data-vv-name="allDataSegments"
            :class="{
    'is-invalid': errors.has(
        'allDataSegments'
    ),
}"
    >
    </b-form-radio-group>
</b-form-group>
<b-form-group
      v-if="!formData.allDataSegments" 
      label="Select Data Segment" 
      label-for="dataSegmentSelect"
    >
      <!-- <b-form-select
        id="dataSegmentSelect"
        v-model="formData.dataSegmentIds"
        :options="dataSegments"
        data-vv-name="dataSegmentIds"
        :class="{
          'is-invalid': errors.has('dataSegmentIds'),
        }"
      >
      </b-form-select> -->
      <multiselect
        v-model="formData.dataSegmentIds"
        placeholder="Select Data Segment"
        label="text"
        track-by="value"
        :options="dataSegments"
        :multiple="true"
        :taggable="true"
        v-validate="{
            required: true,
        }"
        :class="{
    'is-invalid': errors.has(
        'dataSegmentSelect'
    ),
}"
      ></multiselect>
    </b-form-group>

</div>

                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                            :btn-label="buttonLabel"
                            btn-type="submit"
                            btn-variant="primary"
                            :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                            btn-label="Cancel"
                            btn-type="reset"
                            :disabled="loading"
                            btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import request from '@/utils/request'
    import DatePicker from 'vue2-datepicker'
    import Multiselect from "vue-multiselect";

    // Custom URL validation rule
// extend('url', {
//     message: 'Please enter a valid URL',
//     validate: (value) => {
//         const pattern = /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=.]+)?$/;
//         return pattern.test(value);
//     },
// });
    export default {
        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        components:{
        DatePicker,Multiselect
    },
        props: {
            title: {
                type: String,
                default: null,
            },
            buttonText: {
                type: String,
                default: 'Create',
            },
        }, // End of Component > props
        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        computed: {
            ...mapGetters(['loading', 'selectedItem', 'hidePopup']),
            getMeta() {
                let obj = {
                    label:"Description",
                    placeholder:"Enter description",
                    rows:"3",
                    validate:{required:true}
                }
                if(this.formData.category === 'external')
                {
                    obj = {
                    label:"URL",
                    placeholder:"Enter URL",
                    rows:"1",
                    validate:{required:true, url: true}
                }
                }
            // Apply URL validation only if category is 'external'
            return obj
        },
            titlePopup() {
                return this.selectedItem
                    ? 'Modify Notification'
                    : 'Add Notification'
            }, // End of title() method
            isDisabled() {
                return false
                // return this.selectedItem
                //     ? true
                //     : false
            }, // End of title() method

            buttonLabel() {
                return this.selectedItem ? 'Update' : 'Create'
            }, // End of buttonLabel() method
        }, // End of Component > computed

        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        data() {
            return {
                boolVal: [
                    { text: 'Yes', value: true },
                    { text: 'No', value: false },
                ],

                categoryOptions: [
                    { value: null, text: 'Select Category' },
                    { value: 'internal', text: 'Internal' },
                    { value: 'external', text: 'External' },
                ],
                formData: this.initializeFormData(),
                // selectedDataSegment:null
                dataSegments: []
            }
        },
        /*
        |--------------------------------------------------------------------------
        | Component > watch
        |--------------------------------------------------------------------------
        */
        watch: {
            /**
             * Handle when the selected has been updated
             *
             * @return {void}
             */
            selectedItem(value) {
                if (value !== null && value !== undefined) {
                    Object.assign(this.formData, value)
                } else {
                    this.onHidden()
                }
            },
            /**
             * Handle when the popup hide
             *
             * @return {void}
             */
            hidePopup(value) {
                if (value) {
                    this.onHidden()
                }
            },
        },
        /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
       mounted(){
        this.fetchDataSegments();
       },
        methods: {
            disabledDate() {
            return today; // Disable all dates before today
        },
            initializeFormData() {
                return {
                    _id: null,
                    title: null,
                    link: null,
                    description: null,
                    status: 'active',
                    allDataSegments:true,
                    priority:0,
                    dataSegmentIds:null,
                    category:null,
                    expiresAt:null

                }
            },
            /**
             * Handle when the modal is canceled
             *
             * @return {void}
             */
            onHidden() {
                // clear the selected item
                this.$store.commit('clearItem')
                this.$store.commit('onSubmit', null)
                Object.assign(this.formData, this.initializeFormData())
                this.$validator.reset()
                this.$refs.modal.hide()
            }, // End of onHidden() method

            async onSubmit() {
                const result = await this.$validator.validateAll()
                if (result) {
                    try {
                        this.$store.commit('setLoading',true)
                        let {data} = await request.post('configurations/createNotification', this.formData)
                        if(data && data.data)
                        {
                            this.$store.commit('setSuccess', data.message)
                            this.$store.commit('setLoading',false)

                        }

                        this.$store.commit('setError', "Something went wrong")
                        this.$store.commit('setLoading',false)

                    } catch (error) {
                        console.log(error, 'There is an error on submit')
                        this.$store.commit('setLoading',false)
                    }
                } else {
                    this.$store.commit('setError', this.errors.all()[0])
                }
            },
            async fetchDataSegments() {
      try {
        const response = await request.get('access-control/data-segments?perPage=1000');
        this.dataSegments = response.data.data.map(segment => ({
          value: segment._id,
          text: segment.title
        }));
      } catch (error) {
        console.error('Error fetching data segments:', error);
      }
    }
        }, // End of Component > watch
       
    }
</script>
